module.exports = __webpack_public_path__ + "pigmentace_2_before_tn.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures_tn/dermatologie/pigmentace_2_before_tn.jpg
// module id = 1440
// module chunks = 0